import {AddOrRemoveSpinner} from "../utils/utils";

window.addEventListener("pageshow", (e) => {
  AddOrRemoveSpinner();
});
